import React from 'react';
import { AnyObject } from 'final-form';
import { Field } from 'react-final-form';
import { useSelector } from 'react-redux';
import { useMembers } from 'Shared/utils/hooks';
import { required } from 'Shared/utils/formValidations';
import { SimpleAvatar as Avatar } from 'Shared/components/Avatar/Avatar';
import FormSelect from 'Shared/components/FormComponents/FormSelect';

import { compareByCurrentUser } from './utils';

function CustomMemberOption({ innerProps, data: { label, avatar } }: AnyObject) {
  return (
    <div {...innerProps} data-name={label} className="goals-name-and-description-select-option">
      <Avatar size={24} avatar={avatar} className="goals-name-and-description-select-option-avatar" />
      <div>{label}</div>
    </div>
  );
}

const customStyles = {
  control: base => ({ ...base, fontSize: '16px', cursor: 'pointer' }),
  menuList: base => ({ ...base, fontSize: '16px' }),
};

type Props = {
  name: string;
  disabled?: boolean;
  className?: string;
  membersFilter?: Function;
  autoFocus?: boolean;
};

export default function MemberField({ name, className, disabled, autoFocus, membersFilter = array => array }: Props) {
  const membersOptions = useSelector(state =>
    membersFilter(state.members)
      .map(({ id, fullName, email, avatar }) => ({
        value: id,
        label: fullName || email,
        avatar,
      }))
      .sort(compareByCurrentUser(state.user.id))
  );

  const { isLoading: isLoadingMembers } = useMembers();

  return (
    <Field
      disabled={disabled}
      name={name}
      options={membersOptions}
      validate={required}
      customStyles={customStyles}
      className={className}
      component={FormSelect}
      autoFocus={autoFocus}
      isLoading={isLoadingMembers}
      components={{ Option: CustomMemberOption }}
      placeholder="Choose..."
    />
  );
}
